import { Star } from "lucide-react";

const STARS = [0, 1, 2, 3, 4];

export default function ReviewStars() {
  return (
    <div className="flex items-center gap-1 mt-3 mb-4">
      {STARS.map((i) => (
        <Star
          key={i}
          className="w-7 h-7 fill-[var(--accent)] text-[var(--accent)]"
          strokeWidth={1.5}
        />
      ))}
    </div>
  );
}
